module.exports = __webpack_public_path__ + "img/account.1ee16358.svg";